export const BACKSPACE = 8;
